import { Trans } from '@lingui/macro';
import React from 'react';
import { useDispatch } from 'react-redux';

import { sessionLogout } from '../../../../../session';
import { ErrorModalWrapper } from './error-modal.styled';
import {
    Button,
    TeacherAdminIcon
} from '@components';

export const ErrorModal = () => {
    const dispatch = useDispatch();
    const onNavigateToLogin = () => {
        dispatch(sessionLogout());
    };

    return (
        <ErrorModalWrapper data-testid={'error-modal'}>
            <TeacherAdminIcon
                icon={'warning'}
                width={90}
            />

            <p>
                <Trans id={'session.expired'} />
            </p>

            <Button
                data-testid={'ok-button'}
                onClick={onNavigateToLogin}
            >
                <Trans id={'button.ok'} />
            </Button>
        </ErrorModalWrapper>
    );
};
